import { FlowtagPages } from '@dtx-company/true-common/src/types/flowtag'
import { fireHeapEvent } from '../helpers'
import eventNames from '../constants/flowtag'

const ONBOARDING_TYPE = 'FLOWTAG'

const e = {
  userClickedFlowtagBackButton(
    batchId: string,
    page: FlowtagPages,
    ToPage: string,
    educationScreen?: number
  ): void {
    fireHeapEvent(eventNames.userClickedFlowtagBackButton, {
      batchId,
      page,
      ToPage,
      educationScreen,
      flow: ONBOARDING_TYPE
    })
  },
  userClickedFlowtagNextButton(
    batchId: string,
    page: FlowtagPages,
    label?: string,
    educationScreen?: number
  ): void {
    fireHeapEvent(eventNames.userClickedFlowtagNextButton, {
      batchId,
      page,
      label,
      educationScreen,
      flow: ONBOARDING_TYPE
    })
  },
  userTypedFlowtagFormInput(batchId: string, page: FlowtagPages, input: string): void {
    fireHeapEvent(eventNames.userTypedFlowtagFormInput, {
      batchId,
      page,
      input,
      flow: ONBOARDING_TYPE
    })
  },
  userClickedFlowtagFormItem(batchId: string, page: FlowtagPages, item: string): void {
    fireHeapEvent(eventNames.userClickedFlowtagFormItem, {
      batchId,
      page,
      item,
      flow: ONBOARDING_TYPE
    })
  },
  userClickedFlowtagAuthenticationButton(
    batchId: string,
    page: FlowtagPages,
    provider: string
  ): void {
    fireHeapEvent(eventNames.userClickedFlowtagAuthenticationButton, {
      batchId,
      page,
      provider,
      flow: ONBOARDING_TYPE
    })
  },
  userClickedFlowtagEducationSlidesPip(batchId: string, page: FlowtagPages, slide?: number): void {
    fireHeapEvent(eventNames.userClickedFlowtagEducationSlidesPip, {
      batchId,
      page,
      slide,
      flow: ONBOARDING_TYPE
    })
  },
  userSwipedFlowtagEducationSlide(batchId: string, page: FlowtagPages, slide?: number): void {
    fireHeapEvent(eventNames.userSwipedFlowtagEducationSlide, {
      batchId,
      page,
      slide,
      flow: ONBOARDING_TYPE
    })
  },
  userClickedCopySlugName(batchId: string, slugName: string): void {
    fireHeapEvent(eventNames.userClickedCopySlugName, {
      batchId,
      page: FlowtagPages.ActivatedSuccess,
      slugName,
      flow: ONBOARDING_TYPE
    })
  },
  userSelectedExistingPage(pageId: string, batchId: string): void {
    fireHeapEvent(eventNames.userClickedFlowtagNextButton, {
      pageId,
      batchId,
      page: FlowtagPages.ChooseExistingPage,
      flow: ONBOARDING_TYPE
    })
  },
  flowtagActivated(batchId: string): void {
    fireHeapEvent(eventNames.flowtagActivated, {
      batchId,
      status: 'Flowtag activated',
      flow: ONBOARDING_TYPE
    })
  },
  flowtagActivationFailed(batchId: string): void {
    fireHeapEvent(eventNames.flowtagActivationFailed, {
      batchId,
      status: 'Flowtag activation failed',
      flow: ONBOARDING_TYPE
    })
  },
  Flowtag_Socials_Default_CRM_Added(batchId: string, slugName?: string): void {
    fireHeapEvent(eventNames.Flowtag_Socials_Default_CRM_Added, { batchId, slugName })
  },
  Flowtag_Onboarding_Selected_Color(batchId: string): void {
    fireHeapEvent(eventNames.Flowtag_Onboarding_Selected_Color, { batchId })
  }
}

export default e
